/* eslint-disable import/prefer-default-export */
export const signInFormValuesSelector = (state) => state.forms.sign_in
